import { PromotionCard } from './PromotionCard.refactored'

export default PromotionCard
